<template>
  <svg :width="width" :height="height">
    <g :transform="graphTransform">
      <orthogonal-axes
         ref="axes"
         :xLabelRotate="xLabelRotate"
         :xLabelWidth="xLabelWidth"
         :width="graphWidth"
         :height="graphHeight"
         :xTitle="xTitle"
         :yTitle="yTitle"
         :xFormatter="xFormatter"
         :yFormatter="yFormatter"
         :x="x"
         :y="y" >
      </orthogonal-axes>
      <g class="axes" >
        <line :x1="0" :y1="y(0)" :x2="graphWidth" :y2="y(0)" class="axis x" />
      </g>
      <popover
         v-for="(bar, i) in data"
         :key="bar.x"
         :content="popoverFormatter ? popoverFormatter(bar) : yFormatter(bar.y)"
         :delay="100"
         :hideDelay="100" >
        <rect
           @click="handleSelect(bar)"
           :class="selectableClass(bar, ['bar', 'hoverable', {negative: bar.y < 0}])"
           :x="x(bar.x)"
           :y="bar.y >= 0 ? y(bar.y) : y(0)"
           :width="Math.max(x.bandwidth(), 0)"
           :height="Math.max(bar.y >= 0 ? (y(0) - y(bar.y)) : (y(bar.y) - y(0)), 0)"
           :style="{fill: color(bar.y)}" />
      </popover>
    </g>
  </svg>
</template>

<style scoped>
.bar {
    opacity: 0.7;
}
.bar:hover {
    opacity: 1;
}
.bar.selected {
    stroke: red
}
.axes line {
    stroke: #000;
}
</style>

<script>
import * as d3 from 'd3'
import * as d3Chromatic from 'd3-scale-chromatic'
import Graph from './Graph.vue'
import margin from '../mixins/margin.js'
import selectable from '../mixins/selectable.js'
import OrthogonalAxes from './OrthogonalAxes.vue'
import Popover from 'd3vue/components/Popover.vue'

export default {
  extends: Graph,
  mixins: [
    margin,
    selectable
  ],
  components: {
    OrthogonalAxes: OrthogonalAxes,
    Popover: Popover
  },
  props: {
    width: {
      type: Number,
      default: 960
    },
    height: {
      type: Number,
      default: 500
    },
    marginTop: {
      type: Number,
      default: 20
    },
    marginRight: {
      type: Number,
      default: 20
    },
    marginBottom: {
      type: Number,
      default: 30
    },
    padding: {
      type: Number,
      default: 0.1
    },
    popoverFormatter: {
      type: Function,
      required: false
    },
    color: {
      default: () => {
        return d3.scaleSequential(d3Chromatic.interpolateRainbow)
      }
    },
    sortByValue: {
      type: Boolean,
      default: false
    },
    sortReverse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      minY: 0
    }
  },
  computed: {
    x () {
      return d3.scaleBand().rangeRound([0, this.graphWidth]).padding(this.padding)
    },
    y () {
      return d3.scaleLinear().rangeRound([Math.max(this.graphHeight, 0), 0]).clamp(true)
    }
  },
  methods: {
    selectKey (d) {
      return d.x
    },
    update (val) {
      if (val) {
        this.x.domain(val.map(d => d).sort((a, b) => {
          if (!this.sortByValue) {
            return 0
          }
          if (a.y === b.y) {
            return 0
          }
          if (this.sortReverse) {
            return a.y > b.y ? 1 : -1
          }
          return a.y > b.y ? -1 : 1
        }).map(d => {
          return d.x
        }))
        this.minY = Math.min(0, this.min === null ? d3.min(val, d => d.y) : this.min)
        this.y.domain([this.minY, this.max === null ? d3.max(val, d => d.y) : this.max])
        if (typeof this.color.domain !== 'undefined') {
          this.color.domain(this.y.domain())
        }
      } else {
        this.minY = 0
      }
      this.$nextTick(() => {
        this.$refs.axes.draw()
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/d3vue/components/Bar.vue